import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_basics.less'
import { getI18n } from 'client/i18n'

import TipBox from 'components/common/tip_box'
import DateInputBox from 'components/common/date_input_box'
import MoneyTextBox from 'components/common/money_text_box'
import TextBox from 'components/common/text_box'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import { CROWDFUNDING_CAMPAIGN_MAX_DAYS } from 'shared/shared_consts'
import { HeadingText } from '@paypalcorp/pp-react'

export const I18N_CONTEXT = 'components/pages/crowdfunding/pool_basics'
const i18n = getI18n(I18N_CONTEXT)

class CrowdfundingBasics extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    untouchAll: PropTypes.func.isRequired,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    countryCode: PropTypes.string.isRequired,
    shouldAutoFocus: PropTypes.bool,
    formattedMaxGoalAmount: PropTypes.string,
  }

  UNSAFE_componentWillMount = () => {
    this.props.untouchAll()
  }

  componentDidMount() {
    sendEnsightenEvent('MoneyPoolStart')
  }

  constructor(props) {
    super(props)
  }

  render() {
    const {
      fields: { poolName, goalAmount, endDate, postalCode },
      anyInactiveFieldsTouchedWithError,
      formattedMaxGoalAmount,
    } = this.props

    return (
      <form onSubmit={this.props.handleSubmit}>
        <HeadingText size="md" styleName="title">
          {i18n('title')}
        </HeadingText>
        <div>
          <div styleName="textbox-wrapper">
            <TextBox
              title={i18n('pool_name_title')}
              dataNemo="your-pool-name"
              autoFocus={this.props.shouldAutoFocus}
              {...poolName}
            />
          </div>
          <div styleName="textbox-wrapper">
            <MoneyTextBox
              title={i18n('goal_amount_title', {
                maxGoalAmount: formattedMaxGoalAmount,
              })}
              dataNemo="goal-amount"
              disableCents={false}
              {...goalAmount}
            />
          </div>
          <div styleName="textbox-wrapper">
            <DateInputBox
              title={i18n('end_date_title', {
                maxDays: CROWDFUNDING_CAMPAIGN_MAX_DAYS,
              })}
              dataNemo="date-pool-ends"
              {...endDate}
            />
          </div>
          <div styleName="textbox-wrapper zipcode">
            <TextBox
              title={i18n('postal_code_title')}
              dataNemo="postal-code"
              {...postalCode}
            />
          </div>
        </div>
        <div styleName="tip-wrapper">
          <TipBox
            text={i18n('amount_description', {
              maxGoalAmount: formattedMaxGoalAmount,
            })}
          />
        </div>
        <button
          data-nemo="create-basics-next"
          data-pa-click="next"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
        >
          {i18n('next')}
        </button>
      </form>
    )
  }
}

export default cssModules(CrowdfundingBasics, styles, { allowMultiple: true })
